import React from "react";
import BallotSheet from "./BallotSheet";

function Ballot({ judge_uuid, enteredNumber, goBackToDashboard }) {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center bg-gray-100 p-6 rounded-lg shadow-lg max-w-xl mx-auto">
        <p className="text-2xl font-semibold text-gray-800 mb-4">Quick Information</p> {/* Header */}

        <div className="w-full">
          <p className="text-lg font-medium text-gray-700 mb-2">
            <span className="font-semibold">Vehicle #:</span> {enteredNumber.car_number}
          </p> {/* Display the number */}

          <p className="text-lg font-medium text-gray-700 mb-2">
            <span className="font-semibold">Vehicle:</span> {enteredNumber.year + ' ' + enteredNumber.make + ' ' + enteredNumber.model}
          </p> {/* Display the year */}

          {enteredNumber.engine && enteredNumber.engine !== 'X' && (
            <p className="text-lg font-medium text-gray-700 mb-2">
              <span className="font-semibold">Engine:</span> {enteredNumber.engine}
            </p>
          )} {/* Display the engine */}

          {enteredNumber.features && (
            <p className="text-lg font-medium text-gray-700 mb-2">
              <span className="font-semibold">Features:</span> {enteredNumber.features}
            </p>
          )} {/* Display the features */}

          

        </div>
      </div>
      <BallotSheet car_uuid={enteredNumber.uuid} judge_uuid={judge_uuid} goBackToDashboard={goBackToDashboard} /> {/* Pass goBackToDashboard to BallotSheet */}
    </div>
  );
}

export default Ballot;
